import _BaseUserProfile from 'Models/UserProfile/_BaseUserProfile';

export default class UserPhoto extends _BaseUserProfile {
  component = 'PhotoField';
  props = {
    title: 'Please take or upload a photo of yourself for your profile. This will help Operators connect with you when you are bidding on jobs.',
    errorMessage: 'Photo is Required',
    additionalFormInModal: false,
    modalTitle: null,
    additionalFormComponent: null,
  };
  hideClearUntilValue = true;
}
